import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { officeSchema } from "./office";

export const itemSchema = z.object({
  id: z.string().uuid(),
  parentId: z.string().uuid().nullish(),
  officeId: officeSchema.shape.id,
  itemType: z.enum(["folder", "project"]),
  path: z.string(),
  createdAt: z.coerce.date().default(new Date()),
  updatedAt: z.coerce.date().default(new Date()),
});

export const getItemSchema = itemSchema.extend({
  name: z.string(),
});

export const newItemInputSchema = itemSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type Item = z.infer<typeof itemSchema>;
export type GetItem = z.infer<typeof getItemSchema>;
export type ItemInput = z.input<typeof itemSchema>;
export type NewItemInput = z.input<typeof newItemInputSchema>;

export const createItem = (input: NewItemInput): Item => {
  const id = uuidv7();
  const path = [input.path, id].filter((i) => i != null).join("/");
  return newItem({
    ...input,
    id,
    path,
  });
};

export const newItem = (input: ItemInput): Item => itemSchema.parse(input);
